import { AppContext } from "App";
import Errors from "components/base/Errors";
import Page from "components/base/Page";
import Spinner from "components/base/Spinner";
import { useAmazonStockCategories } from "hooks/useAmazon";
import { createContext, useContext } from "react";
import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import { AMAZON_EDITOR } from "utils/permissions";
import { LeftButtons } from "./Header";
import Orders from "./Orders";
import WarehouseRoutes from "./warehouse";

export const AmazonContext = createContext({});

function Index() {
  const { hasPermission } = useContext(AppContext);
  const { loading, error, data } = useAmazonStockCategories();

  if (loading) return <Spinner />;
  if (error) return <Errors error={error} />;

  if (!hasPermission(AMAZON_EDITOR))
    return (
      <div className="flex flex-1 items-center justify-center font-bold text-2xl h-screen text-gray-600">
        Not Allowed.
      </div>
    );

  return (
    <AmazonContext.Provider value={{ stockCategories: data.stockCategories }}>
      <Routes>
        <Route element={<Layout />}>
          <Route path="orders" element={<Orders />} />
          <Route path="warehouses/*" element={<WarehouseRoutes />} />
          <Route path="*" element={<Navigate to="orders" />} />
        </Route>
      </Routes>
    </AmazonContext.Provider>
  );
}

const Layout = () => (
  <Page
    className="h-screen"
    childrenClassName="flex-1 overflow-auto flex flex-col"
    leftButtons={<LeftButtons />}
    rightButtons={
      <a
        href={`${process.env.REACT_APP_SERVER_ADMIN_URL}amazon_vendor_center/sharestocksetting`}
        target="_blank"
        rel="noreferrer"
      >
        Share Stocks
      </a>
    }
  >
    <Outlet />
  </Page>
);

export default Index;
